import * as React from 'react'
import { CardBase } from '@/presentation/components'

type CardNFProps = {
  children: any
}

export const CardNF: React.FC<CardNFProps> = ({ children }: CardNFProps) => {
  return (
    <CardBase>
      {children}
    </CardBase>
  )
}
